import { render, staticRenderFns } from "./BucketStatusTableCell.vue?vue&type=template&id=0ab01d5f&scoped=true"
import script from "./BucketStatusTableCell.vue?vue&type=script&lang=js"
export * from "./BucketStatusTableCell.vue?vue&type=script&lang=js"
import style0 from "./BucketStatusTableCell.vue?vue&type=style&index=0&id=0ab01d5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab01d5f",
  null
  
)

export default component.exports